// https://vuex.vuejs.org/en/mutations.html

export default {
  updateGoogleShoppingIntegrationSearchProduct(state, payload) {
    state.googleShoppingInfo.searchedProducts = payload;
    state.googleShoppingInfo.productLoading = false;
  },
  updateGoogleShoppingIntegrationSearchIncludedProducts(state, payload) {
    state.googleShoppingInfo.productList = payload;
  },
  updateGoogleShoppingIntegrationIncludeProduct(state) {
    state.googleShoppingInfo.selectedProduct = {
      text: '',
      id: null,
    };
  },
  updateGoogleShoppingIntegrationExcludeProduct(state) {
    state.googleShoppingInfo.selectedProduct = {
      text: '',
      id: null,
    };
  },
  updateGoogleShoppingIntegrationStatus(state, payload) {
    state.googleShoppingInfo.status = payload;
    if (!state.googleShoppingInfo.selectedMerchantId && payload.merchants?.length > 0) {
      state.googleShoppingInfo.selectedMerchantId = payload.merchants[0].externalId;
    }
  },
  updateBazaarvoiceIntegrationStatus(state, payload) {
    state.bazaarvoiceStatus = payload;
  },
  setIntegrationProductsPagination(state, payload) {
    state.integrationProducts.pagination = payload;
  },
  setIntegrationProductsLoading(state, payload) {
    state.integrationProducts.pagination.loading = payload;
  },
  loadIntegrationProductsSuccess(state, payload) {
    state.integrationProducts.items = payload.items;
    state.integrationProducts.numUnlinked = payload.numUnlinked;
    state.integrationProducts.pagination.recordsFiltered = payload.recordsFiltered;
    state.integrationProducts.pagination.loading = false;
  },
  setGoogleShoppingSelectedMerchant(state, payload) {
    state.googleShoppingInfo.selectedMerchantId = payload;
  },
};
